'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            mapClass: false,
            mapBtn: true,
            btnZoomInClass: true,
            btnZoomOutClass: false
        };
    },

    props: ['buttonTitle', 'buttonMapTitle'],
    created: function created() {
        this.map = null;
        this.lat = null;
        this.lng = null;
    },

    methods: {
        zoomMap: function zoomMap() {
            if (this.mapClass === false) {
                document.body.style.overflowY = "hidden";
                this.mapClass = true;
                this.mapBtn = false;
                this.btnZoomInClass = false;
                this.btnZoomOutClass = true;
            } else {
                document.body.style.overflowY = "scroll";
                this.mapClass = false;
                this.mapBtn = true;
                this.btnZoomInClass = true;
                this.btnZoomOutClass = false;
            }
            // timeout for delay map redraw, after animation
            setTimeout(this.mapAnimation, 100);
        },
        mapAnimation: function mapAnimation() {
            var self = this;
            var mapAnim = document.getElementById("contact-map");
            var mapBtn = document.getElementById("map-button");
            mapAnim.addEventListener('animationend', self.animationEvent(), true);
            mapAnim.removeEventListener('animationend', self.animationEvent(), true);
            //  removes focus
            mapBtn.blur();
        },
        animationEvent: function animationEvent() {
            var gmap = this.map;
            google.maps.event.trigger(gmap, 'resize');
        },
        mapInit: function mapInit() {
            var self = this;
            /* set up Google map */
            var lat = coordinates.latitude;
            var lng = coordinates.longitude;
            var zoom = 15;
            var baseCoordinates = { lat: parseFloat(lat), lng: parseFloat(lng) };
            self.lat = lat;
            self.lng = lng;

            self.map = new google.maps.Map(document.getElementById('map-canvas'), {
                scrollwheel: false,
                draggable: true,
                center: baseCoordinates,
                zoom: parseInt(zoom),
                mapTypeControl: false,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
                },
                scaleControl: true
            });

            var contentString = document.getElementById("info-box");

            var infoWindow = new google.maps.InfoWindow();
            infoWindow.setOptions({
                content: contentString,
                position: baseCoordinates,
                animation: google.maps.Animation.DROP,
                maxWidth: 240,
                boxStyle: {
                    width: "288px"
                }
            });
            infoWindow.open(self.map);
            google.maps.event.addDomListener(window, 'resize', function () {
                self.map.setCenter(baseCoordinates);
            });
        }
    },
    ready: function ready() {
        google.maps.event.addDomListener(window, 'load', this.mapInit());
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"contact-map--wrap\">\n    <div id=\"contact-map\" class=\"contact-map__content\" v-bind:class=\"{'contact-map--wide': mapClass}\">\n        <div id=\"map-canvas\"></div>\n        <div class=\"contact-map__button\">\n            <a id=\"map-button\" v-on:click=\"zoomMap\" href=\"javascript:void(0);\" class=\"button button--blue button--icon\" v-bind:class=\"{'button--zoom-in': btnZoomInClass, 'button--zoom-out': btnZoomOutClass}\">\n                <span v-if=\"mapBtn\">{{ buttonTitle }}</span>\n                <span v-else=\"\">{{buttonMapTitle}}</span>\n            </a>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-576915e0", module.exports)
  } else {
    hotAPI.update("_v-576915e0", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}